import gql from "graphql-tag";
import { activityFragment, attachmentFragment } from "./fragments";
import { taskFragment } from "../tasks/fragments";
import { commentFragment } from "../comments/fragments";

export const GET_ACTIVITY = gql`
  query getActivity($id: ID!) {
    activity(id: $id) {
      ...ActivityFragment
      tasks {
        ...TaskFragment
      }
      comments {
        ...CommentFragment
      }
      attachments {
        ...AttachmentFragment
      }
    }
  }
  ${activityFragment}
  ${taskFragment}
  ${commentFragment}
  ${attachmentFragment}
`;

export const GET_ACTIVITY_BY_SLUG = gql`
  query GetActivityBySlug($slug: ID!) {
    activityBySlug(slug: $slug) {
      ...ActivityFragment
      tasks {
        ...TaskFragment
      }
      comments {
        ...CommentFragment
      }
      attachments {
        ...AttachmentFragment
      }
    }
  }
  ${activityFragment}
  ${taskFragment}
  ${commentFragment}
  ${attachmentFragment}
`;

export const GET_BASIC_ACTIVITIES = gql`
  query getBasicActivities(
    $searchTerm: String
    $projectId: [ID]
    $assigneeId: [ID]
    $statusId: [ID]
    $sprintId: [ID]
    $milestoneId: [ID]
    $includesInactive: Boolean
    $onlyImportant: Boolean
    $onlyNonAssigned: Boolean
  ) {
    activities(
      searchTerm: $searchTerm
      projectId: $projectId
      assigneeId: $assigneeId
      statusId: $statusId
      sprintId: $sprintId
      milestoneId: $milestoneId
      includesInactive: $includesInactive
      onlyImportant: $onlyImportant
      onlyNonAssigned: $onlyNonAssigned
    ) {
      id
      rank
      name
      description
      estimation
      active
      priority
      blocked
      slug
      activityType
      assignee {
        id
        firstName
        lastName
        avatarUrl
      }
      status {
        id
        rank
        name
      }
      devStatus {
        id
        name
        rank
      }
      sprint {
        id
        number
        label
        projectId
        startDate
        endDate
      }
      deadline
      tasks {
        id
        isDone
      }
      milestone {
        id
        name
        color
        phase {
          id
          name
        }
      }
      createdAt
      updatedAt
      deletedAt
      private
      createdBy {
        id
        firstName
        lastName
        avatarUrl
      }
      project {
        id
        name
        color
        estimationUnit
      }
    }
  }
`;

export const GET_FULL_ACTIVITIES = gql`
  query getFullActivities(
    $searchTerm: String
    $projectId: [ID]
    $assigneeId: [ID]
    $statusId: [ID]
    $sprintId: [ID]
    $milestoneId: [ID]
    $includesInactive: Boolean
    $onlyImportant: Boolean
    $onlyNonAssigned: Boolean
  ) {
    activities(
      searchTerm: $searchTerm
      projectId: $projectId
      assigneeId: $assigneeId
      statusId: $statusId
      sprintId: $sprintId
      milestoneId: $milestoneId
      includesInactive: $includesInactive
      onlyImportant: $onlyImportant
      onlyNonAssigned: $onlyNonAssigned
    ) {
      ...ActivityFragment
      tasks {
        ...TaskFragment
      }
      comments {
        ...CommentFragment
      }
      attachments {
        ...AttachmentFragment
      }
    }
  }
  ${activityFragment}
  ${taskFragment}
  ${commentFragment}
  ${attachmentFragment}
`;

export const GET_ACTIVITY_STATUSES = gql`
  query GetActivityStatuses {
    activityStatuses {
      id
      name
    }
  }
`;

export const GET_ACTIVITY_DEV_STATUSES = gql`
  query GetActivityDevStatuses {
    activityDevStatuses {
      id
      name
      rank
    }
  }
`;
